<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable v-if="value" disabled >
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
					<el-select v-model="filters.mn" filterable v-else >
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-radio-group v-model="mode">
						<el-radio :label="3">三分之一倍程</el-radio>
						<el-radio :label="2">一分之一倍程</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-radio-group v-model="value"  @input="changeLinkage">
						<el-radio :label="true">开启</el-radio>
						<el-radio :label="false">关闭</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>{{ time }}</el-form-item>
			</el-form>
		</el-col>

        <!-- 折线图 -->
        <el-col :span="24"   v-loading="listLoading" id="chartLine">
            <spectrum-line :projectId="filters.projectId.toString()" :mn="filters.mn"  :num="num" :collapsed="collapsed"  :mode="mode"  @select-type="clickChart" ></spectrum-line>
        </el-col>
	</section>
</template>

<script>
	import util from '../../common/js/util'
    import { getProjects,getDevicesByProjectId} from '../../api/api';
    
    import SpectrumLine from '../chartsNoise/SpectrumLine';

	import FormQueryButton from '../../components/myButton/FormQueryButton.vue'

	export default {
		props: {
            collapsed: {
                type: Boolean,
            },
        },	
		components: { FormQueryButton ,SpectrumLine},

		data() {
			return {
				filters: {
					projectId:"",
					mn:""
				},
				listLoading: false,
				devices:[],
				projects:[],
				formHeight:0,

                type:1,
                num:0,
				ppFlag:false,
				time:"",
				value:false,
				mode:3
			}
			
		},
		methods: {
			changeLinkage(){
				if(this.value){
					this.num=1;
				}else{
					this.num=0;
				}
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
				});
            },
			changeQury(type){
				this.num=type;
			},
			clickChart(e,str){
				if(e=="time"){
					this.time=str;
				}else{
					this.value=false;
					this.num=0;
				}
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
                document.getElementById("chartLine").style.height=this.formHeight+"px";
			}
		},
		destroyed() {
			this.num=0;
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			this.getProjects();
		}, 
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// Spectrum.vue?6e5295b5